import React, { Fragment, useContext } from "react";
import { Context } from "../../context/Context";

// Everything under this boundary is thrown away and rebuilt when the signed-in user's effective access changes
// (global access switched on or off, an assignment or role changed, the account disabled). Data a page loaded under the
// old access is therefore never kept on screen: the pages mount again and fetch with the new scope. The URL is kept.
export function AccessEpoch({ children }) {
  const { accessEpoch = 0 } = useContext(Context) || {};
  return <Fragment key={accessEpoch}>{children}</Fragment>;
}

export default AccessEpoch;
